module.exports = __webpack_public_path__ + "img/15.43853f04.png";